import { t } from '@lingui/macro'
import React from 'react'
import { Alert } from 'react-bootstrap'

const ServiceUnavailable: React.FC = () => {
  return <Alert variant="danger">{t`Dieser Service ist aktuell leider nicht verfügbar.`}</Alert>
}

export default ServiceUnavailable
